import React, {Component} from 'react'
import API_Longterm_Root from "../Constants/API_Longterm_Root";
import Loader from 'react-loader-spinner'
import {dateToString} from "../Constants/dateToString";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import {Button, Dropdown} from 'semantic-ui-react'
import DisplayHeader from "../FileDnD/FilesID/DisplayHeader"
import {convertServerDateToDisplayDate} from "../Constants/convertServerDateToDisplayDate";
import DownloadLogs from "./DownloadLogs";

class AccountAnalyticsBody extends Component {
    constructor(props) {
        super(props);

        const today = new Date();
        const weekAgo = new Date();
        weekAgo.setDate(today.getDate() - 7);
        const defaultStart = dateToString(weekAgo).date;
        const defaultEnd = dateToString(today).date;

        this.state = {
            vizInfo: null,
            fetching: false,
            statusFilter: "success",
            fullVizInfo: null,
            allEndpoints: null,
            selectedEndpoints: [],
            dateRangeStart: defaultStart,
            dateRangeEnd: defaultEnd,
        }

        this.reshapeData = this.reshapeData.bind(this);
        this.setStatusFilter = this.setStatusFilter.bind(this);
        this.fetchAnalytics = this.fetchAnalytics.bind(this);
        this.setDateRange = this.setDateRange.bind(this);
    }

    setDateRange(start, end) {
        const startStr = start && start.length >= 10 ? start.substring(0, 10) : this.state.dateRangeStart;
        const endStr = end && end.length >= 10 ? end.substring(0, 10) : this.state.dateRangeEnd;
        this.setState({ dateRangeStart: startStr, dateRangeEnd: endStr }, () => this.fetchAnalytics());
    }

    fetchAnalytics() {
        this.setState({ fetching: true });
        fetch(API_Longterm_Root + "api/get-api-analytics/", {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
            },
            body: JSON.stringify({
                email: localStorage.getItem("email"),
                token: localStorage.getItem("token"),
                webhook: false,
                start_date: this.state.dateRangeStart,
                end_date: this.state.dateRangeEnd,
            })
        }).then(res => res.json())
            .then((data) => {
                if (!data.error){
                    const defaultEndpoints = ["create","read","update","delete","calculate","macros","run_file_analysis","ai","agents","agents_jobs"];
                    const endpointsFromBackend = Array.isArray(data.endpoints) ? data.endpoints : [];
                    const endpointsFromBackendMerged = [...endpointsFromBackend];
                    for (let i=0; i<defaultEndpoints.length; i++){
                        const e = defaultEndpoints[i];
                        if (!endpointsFromBackendMerged.includes(e)){
                            endpointsFromBackendMerged.push(e);
                        }
                    }
                    this.setState({
                        allEndpoints: endpointsFromBackendMerged,
                        vizInfo: this.reshapeData(data.vizInfo, this.state.statusFilter, endpointsFromBackendMerged, this.state.dateRangeStart, this.state.dateRangeEnd),
                        fetching: false,
                        fullVizInfo: data.vizInfo
                    })
                }
                else{
                    this.setState({ fetching: false })
                }
            }).catch((err) => {
                this.setState({ fetching: false });
            }).catch(err => this.setState({ fetching: false }));
    }

    getEndpointDisplayName = (endpoint) => {
        const normalized = String(endpoint || "").trim().toLowerCase();

        if (normalized === "read") return "Read Data";
        if (normalized === "create") return "Create Data";
        if (normalized === "update") return "Update Data";
        if (normalized === "delete") return "Delete Data";
        if (normalized === "calculate") return "Calculate";
        if (normalized === "macros") return "Macro";
        if (normalized === "run_file_analysis") return "Analyze";
        if (normalized === "ai") return "AI";
        if (normalized === "agents") return "Agents";
        if (normalized === "agents_jobs") return "Agent Jobs";

        return endpoint;
    }

    getEndpointHref = (endpoint) => {
        const normalized = String(endpoint || "").trim().toLowerCase();

        if (normalized === "read" || normalized === "delete"){
            return "https://api-spreadsheet-docs.readme.io/reference/get_data-file-id";
        }

        if (normalized === "create" || normalized === "update"){
            return "https://api-spreadsheet-docs.readme.io/reference/post_data-file-id";
        }

        if (normalized === "ai"){
            return "https://api-spreadsheet-docs.readme.io/reference/aiprompt";
        }

        if (normalized === "calculate"){
            return "https://api-spreadsheet-docs.readme.io/reference/calculatedata";
        }

        if (normalized === "macros" || normalized === "macro"){
            return "https://api-spreadsheet-docs.readme.io/reference/runmacro";
        }

        if (normalized === "run_file_analysis" || normalized === "analyze" || normalized === "analysis"){
            return "https://api-spreadsheet-docs.readme.io/reference/getfileanalysis";
        }

        if (normalized === "agents"){
            return "https://api-spreadsheet-docs.readme.io/reference/runagent";
        }

        if (normalized === "agents_jobs"){
            return "https://api-spreadsheet-docs.readme.io/reference/getjobstatus";
        }

        return null;
    }

    isSuccessStatus = (statusCode) => {
        const code = Number(statusCode);
        return code >= 200 && code < 300;
    }

    renderTooltip = ({active, payload, label}) => {
        if (!active || !payload || payload.length === 0){
            return null;
        }

        const count = payload[0] && payload[0].value ? payload[0].value : 0;

        return (
            <div
                style={{
                    backgroundColor: "white",
                    border: "1px solid #E5E7EB",
                    borderRadius: "8px",
                    padding: "8px 10px",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.10)",
                    fontFamily: "Lato"
                }}
            >
                <div style={{fontSize: "12px", color: "#6B7280", marginBottom: "2px"}}>{label}</div>
                <div style={{fontSize: "13px", color: "#111827", fontWeight: 700}}>
                    {count} {count === 1 ? "request" : "requests"}
                </div>
            </div>
        )
    }

    componentWillMount(){
        this.fetchAnalytics();
    }

    setStatusFilter(filter){
        const reshapedData = this.reshapeData(this.state.fullVizInfo, filter, this.state.allEndpoints, this.state.dateRangeStart, this.state.dateRangeEnd);
        this.setState({statusFilter: filter, vizInfo: reshapedData})
    }

    reshapeData(vizInfo, statusFilter, endpointsList=null, startDateStr=null, endDateStr=null){
        const dateArr = [];
        const today = new Date();
        let rangeStart = new Date();
        let rangeEnd = new Date();
        if (startDateStr && endDateStr) {
            try {
                rangeStart = new Date(startDateStr + "T00:00:00");
                rangeEnd = new Date(endDateStr + "T00:00:00");
            } catch (e) {}
        }
        if (!rangeStart.getTime || !rangeEnd.getTime || rangeStart > rangeEnd) {
            rangeEnd = today;
            rangeStart = new Date();
            rangeStart.setDate(today.getDate() - 7);
        }
        const cursor = new Date(rangeStart);
        while (cursor <= rangeEnd) {
            dateArr.push(dateToString(new Date(cursor)).date);
            cursor.setDate(cursor.getDate() + 1);
        }

        const endpointData = {};
        const endpointsSet = new Set();

        if (Array.isArray(endpointsList)){
            for (let i=0; i<endpointsList.length; i++){
                const endpoint = endpointsList[i] || "unknown";
                endpointsSet.add(endpoint);
                endpointData[endpoint] = dateArr.map(d => ({date: d, count: 0}))
            }
        }

        const getTotalForEndpoint = (endpoint) => {
            if (!(endpoint in endpointData)){
                return 0;
            }
            return endpointData[endpoint].reduce((sum, row) => sum + (row.count || 0), 0);
        }

        const sortEndpointsByData = (endpoints) => {
            return endpoints.sort((a, b) => {
                const totalA = getTotalForEndpoint(a);
                const totalB = getTotalForEndpoint(b);

                const hasA = totalA > 0;
                const hasB = totalB > 0;

                if (hasA && !hasB) return -1;
                if (!hasA && hasB) return 1;

                if (totalA !== totalB) return totalB - totalA;

                return String(a).localeCompare(String(b));
            })
        }

        if (!vizInfo || vizInfo.length === 0){
            const endpoints = sortEndpointsByData(Array.from(endpointsSet))
            return {endpointData: endpointData, endpoints: endpoints, dateArr: dateArr}
        }

        for (let i=0; i<vizInfo.length; i++){
            const apiCall = vizInfo[i];

            const crudAction = apiCall.crud_action || "unknown";
            endpointsSet.add(crudAction);

            let callDate = null;
            try{
                callDate = convertServerDateToDisplayDate(apiCall.created_dt.replace("T", " ").substr(0, apiCall.created_dt.indexOf("."))).substr(0, 10);
            } catch (e){
                callDate = null
            }

            if (!callDate){
                continue;
            }

            const dateIdx = dateArr.indexOf(callDate);
            if (dateIdx === -1){
                continue;
            }

            const isSuccess = this.isSuccessStatus(apiCall.status_code);
            if (statusFilter === "success" && !isSuccess){
                continue;
            }
            if (statusFilter === "fail" && isSuccess){
                continue;
            }

            if (!(crudAction in endpointData)){
                endpointData[crudAction] = dateArr.map(d => ({date: d, count: 0}))
            }

            endpointData[crudAction][dateIdx].count += 1
        }

        const endpoints = sortEndpointsByData(Array.from(endpointsSet))
        return {endpointData: endpointData, endpoints: endpoints, dateArr: dateArr}
    }

    render() {
        const successActive = this.state.statusFilter === "success";
        const failActive = this.state.statusFilter === "fail";
        const controlsHeight = 40;

        if (this.state.fetching){
            return(
                <div style={{padding: '100px 0', textAlign: 'center'}}>
                    <Loader
                        type="TailSpin"
                        color="black"
                        height="50"
                        width="50"
                    />
                    <h4 className="thinHeading" style={{color: 'black'}}>Getting your history...</h4>
                </div>
            )
        }

        if (this.state.vizInfo === null){
            return null
        }

        if (!this.state.vizInfo.endpoints || this.state.vizInfo.endpoints.length === 0){
            return (
                <div>
                    <div style={{marginBottom: "16px"}}>
                        <DisplayHeader header="API Usage"/>
                    </div>
                    <h5 className="thinHeading">No API calls found for the selected date range</h5>
                </div>
            )
        }

        return (
            <div>
                <div style={{display: "grid", gridTemplateColumns: "50% 50%", marginBottom: "8px"}}>
                    <div>
                        <DisplayHeader header="API Usage"/>
                    </div>
                    <div style={{textAlign: "right"}}>
                        <DownloadLogs accountWide buttonText="Export" webhook={false}/>
                    </div>
                </div>

                <div style={{borderBottom: "1px solid #F0F0F0", marginLeft: "-16px", marginRight: "-16px"}}/>
                <div className="row" style={{display: "flex", alignItems: "stretch", height: controlsHeight}}>
                    <div className="col-sm-6" style={{display: "flex", alignItems: "stretch"}}>
                        <div style={{display: "flex", alignItems: "stretch"}}>
                            <Button.Group style={{borderRadius: 0, boxShadow: "none", height: "100%"}}>
                                <Button
                                    content="Success"
                                    style={{
                                        borderRadius: 0,
                                        borderTop: "0",
                                        borderBottom: "0",
                                        borderLeft: "1px solid #F0F0F0",
                                        borderRight: "0",
                                        boxShadow: "none",
                                        backgroundColor: successActive ? "#6FBB98" : "white",
                                        color: successActive ? "white" : "black",
                                        fontWeight: successActive ? 700 : 400,
                                        height: "100%",
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                    onClick={() => this.setStatusFilter("success")}
                                />
                                <Button
                                    content="Fail"
                                    style={{
                                        borderRadius: 0,
                                        borderTop: "0",
                                        borderBottom: "0",
                                        borderLeft: "1px solid #F0F0F0",
                                        borderRight: "1px solid #F0F0F0",
                                        boxShadow: "none",
                                        backgroundColor: failActive ? "#6FBB98" : "white",
                                        color: failActive ? "white" : "black",
                                        fontWeight: failActive ? 700 : 400,
                                        height: "100%",
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                    onClick={() => this.setStatusFilter("fail")}
                                />
                            </Button.Group>
                        </div>
                    </div>
                    <div className="col-sm-6" style={{display: "flex", justifyContent: "flex-end", alignItems: "stretch", height: "100%", gap: "16px"}}>
                        <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
                            <div style={{display: "flex", alignItems: "center", gap: "4px", height: "100%"}}>
                                <label style={{fontSize: "12px", color: "#6B7280", whiteSpace: "nowrap", display: "flex", alignItems: "center"}}>From</label>
                                <input
                                    type="date"
                                    value={this.state.dateRangeStart}
                                    max={this.state.dateRangeEnd}
                                    onChange={(e) => this.setDateRange(e.target.value, this.state.dateRangeEnd)}
                                    style={{
                                        width: "132px",
                                        height: "100%",
                                        padding: "4px 8px",
                                        borderLeft: "1px solid #F0F0F0",
                                        borderRight: "1px solid #F0F0F0",
                                        borderBottom: "0",
                                        borderTop: "0",
                                        fontSize: "13px",
                                        fontFamily: "Lato",
                                        color: "#111827",
                                        boxSizing: "border-box"
                                    }}
                                />
                            </div>
                            <div style={{display: "flex", alignItems: "center", gap: "4px", height: "100%"}}>
                                <label style={{fontSize: "12px", color: "#6B7280", whiteSpace: "nowrap", display: "flex", alignItems: "center"}}>To</label>
                                <input
                                    type="date"
                                    value={this.state.dateRangeEnd}
                                    min={this.state.dateRangeStart}
                                    onChange={(e) => this.setDateRange(this.state.dateRangeStart, e.target.value)}
                                    style={{
                                        width: "132px",
                                        height: "100%",
                                        padding: "4px 8px",
                                        borderLeft: "1px solid #F0F0F0",
                                        borderRight: "1px solid #F0F0F0",
                                        borderBottom: "0",
                                        borderTop: "0",
                                        fontSize: "13px",
                                        fontFamily: "Lato",
                                        color: "#111827",
                                        boxSizing: "border-box"
                                    }}
                                />
                            </div>
                        </div>
                        <Dropdown
                            placeholder="Filter endpoints"
                            className="apiUsageEndpointDropdown"
                            fluid
                            multiple
                            search
                            selection
                            clearable
                            value={this.state.selectedEndpoints}
                            options={(this.state.vizInfo && this.state.vizInfo.endpoints ? this.state.vizInfo.endpoints : []).map((e) => ({
                                key: e,
                                text: this.getEndpointDisplayName(e),
                                value: e
                            }))}
                            onChange={(e, data) => this.setState({selectedEndpoints: data.value || []})}
                            style={{minWidth: "200px", maxWidth: "280px", height: "100%"}}
                        />
                    </div>
                </div>
                <div style={{borderBottom: "1px solid #F0F0F0", marginLeft: "-16px", marginRight: "-16px"}}/>


                <div style={{padding: "12px 0"}}>
                    <div className="row" style={{marginLeft: "-8px", marginRight: "-8px"}}>
                        {(this.state.selectedEndpoints && this.state.selectedEndpoints.length > 0
                            ? this.state.vizInfo.endpoints.filter(e => this.state.selectedEndpoints.includes(e))
                            : this.state.vizInfo.endpoints
                        ).map((endpoint) => {
                            const chartData = this.state.vizInfo.endpointData[endpoint] || this.state.vizInfo.dateArr.map(d => ({date: d, count: 0}))
                            const totalRequests = chartData.reduce((sum, row) => sum + (row.count || 0), 0)
                            const href = this.getEndpointHref(endpoint);
                            const isLink = Boolean(href);

                            return (
                                <div
                                    key={endpoint}
                                    className="col-xs-12 col-sm-6"
                                    style={{paddingLeft: "8px", paddingRight: "8px"}}
                                >
                                    <div
                                        style={{
                                            marginBottom: "16px",
                                            border: "1px solid #F0F0F0",
                                            borderRadius: "4px",
                                            backgroundColor: "white",
                                            padding: "12px"
                                        }}
                                    >
                                        <div style={{fontWeight: 700, fontFamily: "Lato", color: "#111827"}}>
                                            {isLink ? (
                                                <a
                                                    href={href}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: "#111827",
                                                        textDecoration: "none",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {this.getEndpointDisplayName(endpoint)} <span style={{color: "#9CA3AF"}}>›</span>
                                                </a>
                                            ) : (
                                                <span style={{color: "#111827"}}>{this.getEndpointDisplayName(endpoint)}</span>
                                            )}
                                        </div>
                                        <div style={{display: "flex", alignItems: "center", gap: "8px", margin: "4px 0 8px 0"}}>
                                            <div style={{fontSize: "12px", color: "#7A7A7A"}}>
                                                {totalRequests} {totalRequests === 1 ? "request" : "requests"}
                                            </div>
                                            <div style={{fontSize: "12px", color: "#7A7A7A"}}>
                                                ({this.state.statusFilter})
                                            </div>
                                        </div>
                                        <div style={{width: "100%", height: 220}}>
                                            <ResponsiveContainer>
                                                <BarChart
                                                    data={chartData}
                                                    barSize={34}
                                                    barCategoryGap="12%"
                                                    margin={{top: 6, right: 8, left: 0, bottom: 0}}
                                                >
                                                    <CartesianGrid
                                                        vertical={false}
                                                        stroke="#F0F0F0"
                                                        strokeDasharray="2 6"
                                                    />
                                                    <XAxis
                                                        dataKey="date"
                                                        tickLine={false}
                                                        axisLine={false}
                                                        interval="preserveStartEnd"
                                                        minTickGap={18}
                                                        tick={{fontSize: 11, fill: "#9CA3AF"}}
                                                        tickFormatter={(value) => String(value).length >= 10 ? String(value).substring(5) : value}
                                                    />
                                                    <YAxis
                                                        allowDecimals={false}
                                                        tickLine={false}
                                                        axisLine={false}
                                                        width={28}
                                                        tick={{fontSize: 11, fill: "#9CA3AF"}}
                                                    />
                                                    <Tooltip cursor={{fill: "rgba(0,0,0,0.03)"}} content={this.renderTooltip} />
                                                    <Bar dataKey="count" fill="#6FBB98" radius={0} />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

export default AccountAnalyticsBody

